import {RouterTabRoutes} from "vue-router-tab";
import clients from "./pages/clients";
import contacts from "./pages/contacts";
import companies from "./pages/companies";
import crm_activity from "./pages/crm_activity";
import finance from "./pages/finance";
import admin from "./pages/admin";
import reports from "./pages/reports";
// import leads from "./pages/leads";
import news from "./pages/news";
import orders from "./pages/orders";
import time_sheets from "./pages/time_sheets";
import workers from "./pages/workers";
import calendar from "./pages/calendar";
import email from "./pages/email";
import tasks from "./pages/tasks";
import company_contracts from "./pages/company_contracts";
import client_routes from "resources/js/router/pages/client_pages";
import sales_service from "resources/js/router/pages/sales_service";

/**
 |--------------------------------------------------------------------------
 | Dashboard
 |--------------------------------------------------------------------------
 */
const dashboard = [
  {
    path: '/', component: require('pages/Dashboard.vue').default,
    meta: {title: 'Dashboard', icon: "fas fa-tachometer-alt"}
  },
  {
    path: '/charge_rate_calculator', component: require('pages/Charge_rate_calculator.vue').default,
    name: 'charge_rate_calculator',
    meta: {requiresAuth: true, title: "Charge rate calculator", icon: "fas fa-calculator"}
  }
];

let page_routes = [];
page_routes = page_routes.concat(
    // Introduce RouterTab built-in routing to support iframe
    ...RouterTabRoutes,
    dashboard,
    clients,
    contacts,
    companies,
    crm_activity,
    reports,
    admin,
    finance,
    // leads,
    news,
    orders,
    time_sheets,
    workers,
    calendar,
    email,
    tasks,
    company_contracts,
    client_routes,
    sales_service
);

export default page_routes;
